function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.8 15.416L10.128 15.344C9.52 15.288 9 14.88 8.8 14.296C8.376 12.728 8.376 11.064 8.8 9.496C10.656 9.12 12 7.496 12 5.6C12 4 10.4 0 10.4 0H5.6C5.6 0 4 4 4 5.6C4 7.504 5.336 9.136 7.2 9.52C7.624 11.088 7.624 12.752 7.2 14.32C7.008 14.896 6.496 15.304 5.896 15.368L5.2 15.44C5.2 15.44 4.8 15.424 4.8 16H11.2C11.2 15.424 10.8 15.416 10.8 15.416ZM5.952 4L6.752 1.6H9.248L10.048 4H5.952Z",
  fill: "currentColor"
});

function SvgNever(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNever);
export default __webpack_public_path__ + "static/media/never.9a7aafd3.svg";
export { ForwardRef as ReactComponent };